"use strict";

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.match");

require("core-js/modules/es.string.replace");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(err) {
  var _opts$tags;

  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var limitErrorCnt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;
  var client = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '未知';
  var Cookie = arguments.length > 5 ? arguments[5] : undefined;
  var Sentry = arguments.length > 6 ? arguments[6] : undefined;

  try {
    var userId = Cookie.get('uid') || Cookie.get('sso_uid') || 'nofound';
    var errObj = null;

    if (err instanceof Error) {
      errObj = err;
    } else if (err instanceof Object) {
      if (err.respMsg || err.errorMsg || err.errMsg || err.respData || err.respCode) {
        errObj = new Error(err.respMsg || err.errorMsg || err.errMsg || '网络异常');
      } else {
        errObj = new Error(JSON.stringify(err));
      }
    } else if (typeof err === 'string') {
      errObj = new Error(err);
    }

    var errorType = type;
    var myLevel = 'info';
    var isSendEmail = 0; // 获取错误类型，并且判断是否发送邮件

    switch (type) {
      case 1:
        errorType = '组件级错误';
        myLevel = 'warning';
        isSendEmail = 1;
        break;

      case 2:
        errorType = '页面级错误';
        myLevel = 'error';
        isSendEmail = 1;
        break;

      case 3:
        // 这个主要是兼容了，@zz-biz/request（@zz-system/request） 里的异步库上报，后面会废弃
        // errorType = '接口错误'; // http接口状态为：状态码大于400 的一些特殊场景
        var statusMap = {
          400: '接口400 错误请求，服务器不理解请求的语法。',
          401: '接口401 未授权，请求要求身份验证。',
          403: '接口403 拒绝访问',
          404: '接口404 服务器找不到请求的网页，接口路径错误',
          405: '接口405 方法禁用，禁用请求中指定的方法。',
          410: '接口410 如果请求的资源已永久删除，服务器就会返回此响应',
          500: '接口500 服务器遇到错误，无法完成请求',
          501: '接口501 尚未实施，服务器不具备完成请求的功能。',
          502: '接口502 错误网关，服务器作为网关或代理，从上游服务器收到无效响应。',
          503: '接口503 服务不可用，服务器目前无法使用（由于超载或停机维护）。',
          505: '接口505 HTTP 版本不受支持 服务器不支持请求中所用的 HTTP 协议版本。'
        };
        var httpStatus = (opts === null || opts === void 0 ? void 0 : (_opts$tags = opts.tags) === null || _opts$tags === void 0 ? void 0 : _opts$tags.httpStatus) || 0;

        if (statusMap[httpStatus]) {
          var currError = statusMap[httpStatus];
          errorType = currError;
          myLevel = 'error';
          isSendEmail = 1;
        } else {
          errorType = '接口异常';
          myLevel = 'info';
        }

        break;

      case 4:
        errorType = '服务器错误';
        myLevel = 'warning';
        isSendEmail = 1;
        break;

      case 5:
        errorType = '请求失败';
        myLevel = 'warning';
        isSendEmail = 1;
        break;

      case 6:
        errorType = '请求未知错误';
        myLevel = 'warning';
        break;

      case 7:
        errorType = 'promise没有设置catch';
        myLevel = 'info';
        break;

      case 8:
        errorType = '提示类信息';
        myLevel = 'info';
        break;

      case 'error':
        // --- 新等级规则 error
        isSendEmail = 1;
        errorType = '严重';
        myLevel = 'error';
        break;

      case 'warning':
        // --- 新等级规则 warning
        isSendEmail = 1;
        errorType = '警告';
        myLevel = 'warning';
        break;

      case 'info':
        // --- 新等级规则 info
        errorType = '提示';
        myLevel = 'info';
        break;

      default:
        myLevel = 'info';
        errorType = '提示';
        break;
    } // tag信息，辅助快速定位错误


    var t = Cookie.get('zz_t') || Cookie.get('t') || '';
    var ua = navigator.userAgent.match(/zzVersion\/(.*?)\s/) ? navigator.userAgent.match(/zzVersion\/(.*?)\s/)[1] : '';
    var version = Cookie.get('v') || ua;
    var errorMessage = errObj && errObj.message;
    var tagsDefault = {
      errorType: errorType,
      client: client,
      errInfo: errorMessage,
      env: process.env.NODE_ENV || '未知',
      isSendEmail: isSendEmail,
      t: t,
      version: version,
      myLevel: myLevel,
      // 枚举：error waring info
      level: myLevel,
      tVersion: "".concat(t, " ").concat(version),
      uid: userId || '未知',
      tel: Cookie.get('tel') || ''
    };
    var extraDefault = {
      cookie: Cookie.get(),
      UA: navigator.userAgent
    };
    var isTesting = window['__PAGE_META__'] && window['__PAGE_META__'].env == 'testing'; // 测试和沙箱环境不上报

    if (isTesting) return;

    if (typeof location !== 'undefined') {
      tagsDefault.route = location.hash && location.hash.replace(/(#)([^\?]*)(\?.*)*/g, '$2') || location.href;
    } // 主动上报过滤信息：过滤异步库-业务接口提示(和自动上报重复发)


    var canCaptureExcept = errorMessage && !(errorMessage.indexOf('v-on handler (Promise/async)') > -1);
    var tags = Object.assign(tagsDefault, opts.tags || {});
    var extra = Object.assign(extraDefault, opts.extra || {});
    var fingerprint = [process.env.NODE_ENV, errorType, errorMessage];
    var other = {
      message: errorMessage,
      tags: tags,
      extra: extra,
      fingerprint: fingerprint
    };

    if (canCaptureExcept) {
      // 主动发送错误
      if (client === '小程序') {
        Sentry.captureException(errObj, other);
      } else {
        Sentry.withScope(function (scope) {
          scope.setTags(tags);

          if (['info', 'error', 'warning'].includes(myLevel)) {
            // 原来的等级：fatal 致命；error 严重；warning 警告；info 提示 =》 对应现在三个 error、warning和info
            scope.setLevel(myLevel);
          }

          scope.setExtras(extra); // 主动上报时，不这么加其他参数无法合并

          Sentry.captureException(errObj, other);
        });
      }
    }
  } catch (err) {
    console.warn(err);
  }
};

exports.default = _default;